const Collapsible = {
    init: function () {
        $(".collapsible-header").on("click", function () {
            const group = $(this).closest(".collapsible-group");
            const item = $(this).closest(".collapsible-item");

            // Remove "active" class from all other .collapsible-item elements in the group
            group.find(".collapsible-item").not(item).removeClass("active");

            // Toggle "active" on the clicked item
            item.toggleClass("active");
        });
    },
};

export { Collapsible };
